var map = {
	"./IMG_0316.jpg": 943,
	"./IMG_0326.jpg": 814,
	"./IMG_0331.JPG": 379,
	"./IMG_0349.jpg": 760,
	"./IMG_0365.JPG": 392,
	"./IMG_0378.jpg": 307,
	"./IMG_0391.jpg": 476,
	"./IMG_0392.JPG": 198,
	"./IMG_0399.JPG": 641,
	"./IMG_0405.JPG": 305,
	"./IMG_0408.jpg": 337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 945;